import React from 'react'
import HeaderMobile from './HeaderMobile/HeaderMobile'
import MenuDesktop from './MenuDesktop'

export default function Menu () {
  return (
    <>
      <MenuDesktop />
      <HeaderMobile />
    </>
  )
}
